console.log("TAB MANAGER LOADED ✔️");
// Ouvre un onglet
function openTabFeed(evt, sectionId, tabName) {
  // Masquer tous les contenus d’onglet de cette section
  const tabcontent = document.getElementsByClassName(
    'products-feed__tabcontent--' + sectionId
  );
  for (let i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = 'none';
  }

  // Enlever la classe "active" de tous les boutons de cette section
  const tablinks = document.getElementsByClassName(
    'products-feed__tablinks--' + sectionId
  );
  for (let i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(' active', '');
  }

  // Afficher l’onglet demandé
  const tabEl = document.getElementById(tabName);
  if (tabEl) {
    tabEl.style.display = 'block';
  }

  // Ajouter la classe active sur le bouton cliqué
  if (evt && evt.currentTarget) {
    evt.currentTarget.className += ' active';

    // Sur mobile, on force le scroll tout à gauche des pillules
    const parentTabs = evt.currentTarget.closest('.products-feed__tab');
    if (parentTabs) {
      parentTabs.scrollLeft = 0;
    }
  }
}

// ---------- INIT AUTO : activer la première pillule ----------

function initProductsFeedTabs() {
  // Pour chaque groupe de pillules
  const tabContainers = document.querySelectorAll('.products-feed__tab');

  tabContainers.forEach((container) => {
    // On remonte jusqu'à la section pour récupérer son id
    const sectionEl = container.closest('[data-section-id]');
    if (!sectionEl) return;

    const sectionId = sectionEl.getAttribute('data-section-id');

    // Bouton marqué data-default-open (le premier onglet)
    const defaultBtn = container.querySelector('[data-default-open]');
    if (!defaultBtn) return;

    // On récupère le tabName à partir de l’attribut onclick
    const onclickValue = defaultBtn.getAttribute('onclick') || '';
    const match = onclickValue.match(/,\s*'([^']+)'\)\s*$/);
    if (!match) return;
    const tabName = match[1];

    // On appelle openTabFeed "manuellement"
    openTabFeed({ currentTarget: defaultBtn }, sectionId, tabName);
  });
}

// On lance l’init au bon moment
(function () {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductsFeedTabs);
  } else {
    initProductsFeedTabs();
  }

  // Pour l’éditeur de thème Shopify
  document.addEventListener('shopify:section:load', initProductsFeedTabs);
})();
